import { render, staticRenderFns } from "./azure.vue?vue&type=template&id=7695e884&scoped=true&"
import script from "./azure.vue?vue&type=script&lang=js&"
export * from "./azure.vue?vue&type=script&lang=js&"
import style0 from "./azure.vue?vue&type=style&index=0&id=7695e884&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7695e884",
  null
  
)

export default component.exports